export const DealerStatus = {  
  Live: "Live",
  Inactive: "Inactive",
  };